// @ts-nocheck

import { createSelector } from 'reselect';

import { selectMatchAwayScore, selectMatchHomeScore } from '../../../../selectors/match.selector';

const selectRugbyTryAnimationProps = createSelector(
  [selectMatchHomeScore, selectMatchAwayScore],
  (homeScore, awayScore) => ({
    homeScore,
    awayScore,
  }),
);

export default selectRugbyTryAnimationProps;
